<template>
<w-map-popup :title="`[VM상세정보] ${name()}`">
<!-- <w-map-popup :title="`[VM상세정보] ${vmInfo.objName}`"> -->
<el-row style="height: 100%;">
  <el-col :span="13">
    <el-row type="flex" style="height: 170px;">
      <el-col :md="24" :lg="24">
        <table class="list-none-border">
          <tr>
            <th>운영상태</th>
            <td>{{getEmptyText(configInfoData['VVM_COMMON/ALIVE'])}}</td>
          </tr>
          <tr>
            <th>IP</th>
            <td>{{getEmptyText(configInfoData['VVM_COMMON/IPADDRESS'])}}</td>
          </tr>
          <tr>
            <th>상위 호스트</th>
            <td>{{`${getEmptyText(configInfoData['VVM_COMMON/HOST_NAME'])} (${getEmptyText(configInfoData['VVM_COMMON/HOST_IPADDRESS'])})`}}</td>
          </tr>
          <tr>
            <th>VM 운영체제</th>
            <td>{{getEmptyText(configInfoData['VVM_COMMON/OS'])}}</td>
          </tr>
          <tr>
            <th>CPU / 메모리 용량</th>
            <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VVM_CPU/TOTAL_CAPACITY']), 'MB', true, false, true))}}hz
              / {{getEmptyText(convertValuByUnit(Number(configInfoData['VVM_MEM/TOTAL_CAPACITY']), 'MB', true, false, true))}}B
            </td>
          </tr>
          <tr v-if="configInfoData['VVM_COMMON/BOOT_TIME']">
            <th>기동시각</th>
            <td>{{getEmptyText(configInfoData['VVM_COMMON/BOOT_TIME'])}}  ( {{getEmptyText(configInfoData.periodBootTime)}} )</td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" style="height: 135px" v-if="!isEmptyData">
      <el-col :span="6" style="width: 135px; height: 135px">
        <w-solid-gauge-chart ref="vvmCpu" :title="CPU_USERATE_DEFINE"></w-solid-gauge-chart>
      </el-col>
      <el-col :span="6" style="width: 135px; height: 135px">
        <w-solid-gauge-chart ref="vvmMem" :title="MEM_USERATE_DEFINE"></w-solid-gauge-chart>
      </el-col>
      <el-col :span="6" style="width: 135px; height: 135px">
        <w-solid-gauge-chart ref="vvmDisk" :title="DISK_USERATE_DEFINE"></w-solid-gauge-chart>
      </el-col>
      <el-col :span="6" style="width: 135px; height: 135px">
        <w-solid-gauge-chart ref="vvmNetwork" :title="NETWORK_IO_DEFINE"></w-solid-gauge-chart>
      </el-col>
    </el-row>
  </el-col>
  <el-col :span="11" style="height: 100%; padding-left: 10px; height: 100%; border-left: 1px solid rgb(224, 224, 224);">
    <el-table-wrapper :column-default="columnDefault" :data="tableData" :columns="tableColumn" :pagination="false"
      ref="eventTable" style="width:100%;">
      <template slot-scope="scope" slot="eventlevel-slot">
        <w-eventlevel-cell mini :eventlevel-id="scope.row.eventlevelId" />
      </template>
      <template slot-scope="scope" slot="event-message-slot">
        <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
          동적
        </div>
        <span class="link c-pointer" @click="clickEventMessage(scope.row)">{{scope.row.eventMessage}}</span>
      </template>
    </el-table-wrapper>
  </el-col>
</el-row>
<!-- <div class="full virtual-map-info" style="height: 100%;">
  <el-scrollbar class="timeline" style="height: 100%">
    <div style="height: 100%;">
      <el-row type="flex" style="height: 160px;">
        <el-col :md="24" :lg="24">
          <table class="list-none-border">
            <tr>
              <th>운영상태</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/ALIVE'])}}</td>
            </tr>
            <tr>
              <th>IP</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/IPADDRESS'])}}</td>
            </tr>
            <tr>
              <th>VM 운영체제</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/OS'])}}</td>
            </tr>
            <tr>
              <th>CPU / 메모리 용량</th>
              <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VVM_CPU/TOTAL_CAPACITY']), 'MB', true, false, true))}}hz
                / {{getEmptyText(convertValuByUnit(Number(configInfoData['VVM_MEM/TOTAL_CAPACITY']), 'MB', true, false, true))}}B
              </td>
            </tr>
            <tr v-if="configInfoData['VVM_COMMON/BOOT_TIME']">
              <th>기동시각</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/BOOT_TIME'])}}  ( {{getEmptyText(configInfoData.periodBootTime)}} )</td>
            </tr>
            </table>
          </el-col>
      </el-row>
      <div class="mr-b30" style="height: 200px">
        <el-row type="flex" justify="center">
          <el-col :span="6" style="width: 150px; height: 200px;">
            <w-virtual-map-pie-chart ref="vvmCpu" :title="CPU_USERATE_DEFINE"></w-virtual-map-pie-chart>
          </el-col>
          <el-col :span="6" style="width: 150px; height: 200px;">
            <w-virtual-map-pie-chart ref="vvmMem" :title="MEM_USERATE_DEFINE"></w-virtual-map-pie-chart>
          </el-col>
          <el-col :span="6" style="width: 150px; height: 200px;">
            <w-virtual-map-pie-chart ref="vvmDisk" :title="DISK_USERATE_DEFINE"></w-virtual-map-pie-chart>
          </el-col>
          <el-col :span="6" style="width: 150px; height: 200px;">
            <w-virtual-map-pie-chart ref="vvmNetwork" :title="NETWORK_IO_DEFINE"></w-virtual-map-pie-chart>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      이벤트 테이블
    </div>
  </el-scrollbar>
</div> -->
</w-map-popup>
</template>

<script>

import MapConst from '@/constants/topologymap';
import VirtualAPI from '@/api/virtual/performance/config';
import VirtualMapApi from '@/api/virtual/performance/virtualmap';

import Base from '@/mixins/topologymap/base';

import WEventlevelCell from '@/components/table/EventlevelCell';

import WSolidGaugeChart from '@/views/dashboard/widgets/grid/view/components/SolidGaugeChart';
import { columnDefault } from '@/constants/table';

import { getDateToString, calcUptime } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { isEmpty } from '@/utils/basic';
import { openFaultAnalysisPopup } from '@/utils/event';

// import isEmpty from 'lodash/isEmpty';
import camelCase from 'lodash/camelCase';
import forEach from 'lodash/forEach';

// import { isEmpty } from '@/utils/basic';

import WMapPopup from '@/views/topologymap/components/MapPopup';
import { Q, MapInfo } from '@/views/topologymap/js/maps';

const INFO_TYPE = {
  NAME: 'name',
  SUB_MAP: 'sub_map',
  IP: 'ip',
  IF: 'interface',
};

const VVM_RSC_DEFINE = [
  { rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' },
  { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' },
  { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' },
  { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_IN', rscKey: '_' },
  { rsctypeId: 'VVM_NETWORK', rscId: 'BPS_OUT', rscKey: '_' },
];

const CPU_USERATE_DEFINE = 'CPU 사용률 (%)';
const MEM_USERATE_DEFINE = '메모리 사용률 (%)';
const DISK_USERATE_DEFINE = '스토리지 사용률 (%)';
const NETWORK_IO_DEFINE = '네트워크 I/O  (bps)';

export default {
  name: 'WVmDetailInfoWindow',
  components: {
    WEventlevelCell,
    WMapPopup,
    WSolidGaugeChart,
  },
  mixins: [Base],
  data() {
    return {
      CPU_USERATE_DEFINE,
      MEM_USERATE_DEFINE,
      DISK_USERATE_DEFINE,
      NETWORK_IO_DEFINE,
      INFO_TYPE,
      /**
       * 선택 된 오브젝트 모델
       * @type {Q.Node}
       */
      target: null,
      /**
       * 테이블 로딩 플래그
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * 팝업 속성
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        width: 1000,
        height: 380,
        clickToClose: false,
        scrollable: true,
        resizable: true,
        draggable: '.popup-header',
      },
      events: {
        shown(evt) {
          const thisPopup = evt.popup;
          thisPopup.currentTarget = evt.data.target;
        },
        hidden(evt) {
          const thisPopup = evt.popup;
          thisPopup.configInfoData = {};
          thisPopup.pieData = [];
          thisPopup.netIoData = [];
          thisPopup.tableData = [];
          thisPopup.perfParams.objIds = [];
        },
      },
      pieData: [],
      netIoData: [],
      isEmptyData: false,
      configInfoData: {},
      columnDefault,
      tableData: [],
      tableColumn: [
        {
          prop: 'eventlevelId',
          label: '등급',
          key: 'eventlevelId',
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          className: 'eventlevel',
          width: 70,
        },
        {
          prop: 'objName',
          label: '대상',
          key: 'objName',
          headerAlign: 'center',
          width: 100,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          key: 'eventMessage',
          headerAlign: 'center',
          scopedSlot: 'event-message-slot',
        },
        {
          prop: 'checkDatetime',
          label: '최초발생시각',
          headerAlign: 'center',
          width: 140,
          formatter: this.getDateFormatter,
        },
      ],
      perfParams: {
        limit: 10,
        managetypeId: 'VMS',
        managetypeKey: 'VVM',
        objIds: [],
        rscInfoList: VVM_RSC_DEFINE,
        selectedType: 'OBJ',
      },
      attr: {
        fontSize: '10.5px',
        isShowUnit: false,
        y: 120,
        margin: [0, 10, 20, 0],
      },
      convertValuByUnit,
    };
  },
  computed: {
    currentTarget: {
      get() {
        return this.target;
      },
      set(value) {
        this.target = value;
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * 대상 이름 반환
     * @author KangBonghun(toto1323)
     * @return {String} 대상 이름
     */
    name() {
      if (this.currentTarget) {
        return this.currentTarget.get('objName');
      }
      return '-';
    },
    /**
     * 대상 아이피 반환
     * @author KangBonghun(toto1323)
     * @return {String} 대상 아이피
     */
    ip() {
      if (this.currentTarget) {
        return this.currentTarget.get('model').ipaddress;
      }
      return '-';
    },
    /**
     * 이벤트 개수 반환
     * @author KangBonghun(toto1323)
     * @return {String} 이벤트 개수
     */
    eventCnt() {
      return this.eventList.length;
    },
    /**
     * 이벤트 리스트 데이터 로드
     * @author KangBonghun(toto1323)
     */
    loadData() {
      this.isLoading = true;

      const objId = this.currentTarget.get('model').objId;
      const objtypeId = this.currentTarget.get('model').objtypeId;

      VirtualAPI.getNodeConfigInfoForObjtype({
        objId,
        objtypeId,
      }).then((response) => {
        if (response.data.success) {
          this.configInfoData = response.data.data[0];
          this.configInfoData.periodBootTime = calcUptime(new Date(this.configInfoData['VVM_COMMON/BOOT_TIME']), new Date());
        }
        this.isLoading = false;
      });

      this.perfParams.objIds.push(objId);
      VirtualMapApi.getOrderNRscRslt(this.perfParams).then((res) => {
        if (res.data.success) {
          // 파이형태의 데이터 가공
          this.pieData = [];
          this.netIoData = [];
          if (!isEmpty(res.data.data)) {
            this.isEmptyData = false;
            forEach(res.data.data, (data) => {
              if (isEmpty(data.value)) {
                data.value = 0;
              }
              if (data.rsctypeId !== 'VVM_NETWORK') {
                this.pieData.push(data);
                this.$refs[camelCase(data.rsctypeId)].setData(this.makeChartData(data), objtypeId, this.attr);
              } else {
                this.netIoData.push(data);
              }
            });
            this.$nextTick(() => {
              this.$refs.vvmNetwork.setData(this.makeNetIoChartData(this.netIoData), objtypeId, this.attr);
            });
          } else {
            this.isEmptyData = true;
          }
        }
      });

      VirtualMapApi.getEventStatusListForVirtualMap({
        objId,
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
        }
      });
    },
    /**
     * 발생시각 컬럼 포멧
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(value) {
      if (!isEmpty(value.checkDatetime)) {
        return getDateToString(value.checkDatetime, 'YYYY-MM-DD HH:mm');
      }
      return EMPTY_TEXT;
    },
    /**
     * 장애메시지 클릭시 장애 연계
     * @author KangBonghun(toto1323)
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickEventMessage(row) {
      openFaultAnalysisPopup(row.seqNumber);
    },
    /**
     * 대상 이름 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} rowData [description]
     * @param  {[type]} event   [description]
     * @return {[type]}         [description]
     */
    onObjNameClick(rowData, evt) {
      const objId = rowData.objId;
      MapInfo.getInstance(this).getToolbar(MapConst.VIEW_MODE.MONITORING).showMapListMenu(evt, {
        objId,
      });
    },
    getEmptyText(value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    makeChartData(data) {
      let chartData = {};
      const seriesData = [];
      if (!isEmpty(data)) {
        seriesData.push({
          convertValue: convertValuByUnit(Number(data.value), data.unit, true),
          y: Number(data.value),
          // y: isEmpty(data.value) ? null : Number(data.value),
          radius: '110%',
          color: '#568bd2',
          innerRadius: '88%',
          name: isEmpty(data.objName) ? ' ' : data.objName,
          label: data.rscName,
        });
      }
      const pane = {
        startAngle: 0,
        endAngle: 360,
        background: [{ // Track for Move
          outerRadius: '110%',
          innerRadius: '88%',
          backgroundColor: '#f4f4f5',
          borderWidth: 0,
        }],
      };
      chartData = {
        seriesData,
        pane,
      };
      // chartData = data;
      return chartData;
    },
    makeNetIoChartData(data) {
      let chartData = {};
      const seriesData = [];
      const maxValue = data[0].value + data[1].value;
      if (!isEmpty(data)) {
        seriesData.push({
          convertValue: convertValuByUnit(Number(data[0].value), data[0].unit, true, null, true),
          y: Number(data[0].value) / 100,
          // y: isEmpty(data.value) ? null : Number(data.value),
          color: '#568bd2',
          radius: '110%',
          innerRadius: '88%',
          ioType: (data[0].rscId === 'BPS_OUT') ? 'out' : 'in',
          name: isEmpty(data[0].objName) ? ' ' : data[0].objName,
          label: data[0].rscName,
          unit: data[0].unit,
        });
        seriesData.push({
          convertValue: convertValuByUnit(Number(data[1].value), data[1].unit, true, null, true),
          y: Number(data[1].value) / 100,
          // y: isEmpty(data.value) ? null : Number(data.value),
          color: '#fd7484',
          radius: '85%',
          innerRadius: '63%',
          ioType: (data[1].rscId === 'BPS_OUT') ? 'out' : 'in',
          name: isEmpty(data[1].objName) ? ' ' : data[1].objName,
          label: data[1].rscName,
          unit: data[1].unit,
        });
      }
      const pane = {
        startAngle: 0,
        endAngle: 360,
        background: [{ // Track for Move
          outerRadius: '110%',
          innerRadius: '88%',
          backgroundColor: '#f4f4f5',
          borderWidth: 0,
        },
        { // Track for Move
          outerRadius: '85%',
          innerRadius: '63%',
          backgroundColor: '#f4f4f5',
          borderWidth: 0,
        }],
      };
      chartData = {
        seriesData,
        pane,
        maxValue,
      };
      return chartData;
      // if (!isEmpty(data)) {
      //   data.forEach((item) => {
      //     // chartData.push({
      //     //   convertValue: convertValuByUnit(Number(item.value), item.unit, true),
      //     //   y: isEmpty(item.value) ? null : Number(item.value),
      //     //   radius: '110%',
      //     //   innerRadius: '88%',
      //     //   name: isEmpty(item.objName) ? ' ' : item.objName,
      //     // });
      //     item.convertValue = convertValuByUnit(Number(item.value), item.unit, true);
      //     item.y = isEmpty(item.value) ? null : Number(item.value);
      //     item.name = isEmpty(item.objName) ? ' ' : item.objName;
      //   });
      // }
      // chartData = data;
      //
      // const pane = {
      //   startAngle: 0,
      //   endAngle: 360,
      //   background: [{ // Track for Move
      //     outerRadius: '110%',
      //     innerRadius: '88%',
      //     backgroundColor: '#f4f4f5',
      //     borderWidth: 0,
      //   }],
      // };
    },
  },
};
</script>

<style module>
.click-item {
  color: #1c53ca !important;
}

.click-item:hover {
  text-decoration: underline;
  cursor: pointer !important;
}

.info {
  height: 50px;
  width: 100%;
  border-color: #4b7cd0 #6b85aa #667994 #6b85aa;
  border-width: 1px;
  border-style: solid;
  box-shadow: inset 0 2px 0 #4b7cd0,0 1px 1px #d5d5de!important;
  border-radius: 4px;
  padding: 17px 15px 15px 15px;
  line-height: 20px;
}

.table {
  width: 100%;
  height: calc(100% - 60px);
  margin-top: 10px;
}

.info-content {
  display: inline-block;
  margin-right: 30px;
}

.info-content > label:first-child {
  font-weight: 500;
  margin-right: 15px;
  background-image: url(../../../../assets/img/topologymap/dot.png);
  background-repeat: no-repeat;
  background-position: left;
  padding-left: 9px;
}
/* .eventlevel-cell {
  border-left: 3px solid;
  height: 100%;
  width: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/VmDetailInfoWindow.vue